import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { ProFeedback } from 'modules/marketing-pages/marketing-page.types';

import ClientReviewCardNew from '@z-components/molecules/ClientReviewCardNew';
import ProCard from 'modules/marketing-pages/components/ListPros/ProCard';
import ReviewCard from '@z-components/molecules/ClientReviewCard/ClientReviewCard';

import { createReviewMessageWithHeaderAndFooter } from 'utils/data-transform/review';
import { logEvent } from 'utils/analytics';

import styles from './ListRecentReviews.module.scss';

interface Props {
  featureFlags: { isReviewsQAEnabled: boolean };
  jobTypeId: string;
  newestReviews: Array<ProFeedback>;
}

const ListRecentReviews: FC<Props> = ({ featureFlags, jobTypeId, newestReviews }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const handleGoogleAnalyticsProProfileInReviewSection = useCallback(
    (eventType: string) => {
      logEvent(`LandingPagePro:${jobTypeId}`, `${eventType}`);
    },
    [jobTypeId]
  );

  return (
    <div className={styles['recent-reviews-container']}>
      {newestReviews.map((newestReview) => (
        <div key={newestReview._id} className={styles['recent-review-item']}>
          {newestReview.pro && (
            <>
              <ProCard
                isExtendedSectionEnabled={false}
                jobTypeId={jobTypeId}
                onGoogleAnalytics={handleGoogleAnalyticsProProfileInReviewSection}
                isReviewsQAEnabled={false}
                pro={newestReview.pro}
              />
              <hr />
            </>
          )}
          {featureFlags.isReviewsQAEnabled ? (
            <ClientReviewCardNew
              inline={false}
              compact={false}
              rating={newestReview.rating}
              time={newestReview.time}
              title={newestReview.title}
              ratingPersonality={newestReview.ratingPersonality}
              ratingQuality={newestReview.ratingQuality}
              message={newestReview.message}
              nickname={newestReview.nickname}
              questionAnswers={newestReview.questionAnswers}
              age={newestReview.age}
              pricing={newestReview.pricing}
              prefecture={newestReview.prefectureName}
            />
          ) : (
            <ReviewCard
              locale={language}
              message={createReviewMessageWithHeaderAndFooter(newestReview, t)}
              rating={Number(newestReview.rating)}
              time={newestReview.time}
              title={t('marketingPages:reviewTitle', {
                displayName: newestReview.displayName,
              })}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ListRecentReviews;
